import React, { useEffect, useState } from 'react';
import styles from './typeform.module.scss';
import { createWidget } from '@typeform/embed';
import { get_cookie } from '../../helper';
import { getEmail } from '../../helpers/email';
import '@typeform/embed/build/css/widget.css';

const TypeformComponent = () => {
    const [showSkipButton, setShowSkipButton] = useState(true);
    const [widgetInstance, setWidgetInstance] = useState(null);

    function generateUUID() {
        const hexDigits = '0123456789abcdef';
        let uuid = '';
        for (let i = 0; i < 36; i++) {
            if (i === 8 || i === 13 || i === 18 || i === 23) {
                uuid += '-';
            } else if (i === 14) {
                uuid += '4';
            } else if (i === 19) {
                uuid += hexDigits[(Math.random() * 4 | 8)];
            } else {
                uuid += hexDigits[(Math.random() * 16 | 0)];
            }
        }
        return uuid;
    }

    const initTypeform = (tf_url) => {
        const tf_uuid = localStorage.getItem('typeform_uuid') || (() => {
            const uuid = generateUUID();
            localStorage.setItem('typeform_uuid', uuid);
            return uuid;
        })();

        const form_id = tf_url.substring(tf_url.lastIndexOf('/') + 1);
        localStorage.setItem('typeform_id', form_id);

        window.dataLayer?.push({ event: 'start_quiz' });

        const container = document.getElementById('typeform-container');
        if (container) container.innerHTML = ''; // Clear previous instance

        const widget = createWidget(tf_url, {
            container,
            inlineOnMobile: true,
            hidden: { 
                user_uuid: tf_uuid,
                initial_page: get_cookie('initial_page'),
                last_page: get_cookie('last_page'),
                current_page: get_cookie('current_page'),
                utm_audience: get_cookie('utm_audience'),
                utm_platform: get_cookie('utm_platform'),
                aff_id: get_cookie('aff_id'),
                referrer: get_cookie('utm_referrer'),
                referrer_domain: get_cookie('referrer_domain'),
                checkout_path: get_cookie('checkout_path'),
                email: getEmail(),
            },
            tracking: {
                utm_source: get_cookie('utm_source'),
                utm_medium: get_cookie('utm_medium'),
                utm_campaign: get_cookie('utm_campaign'),
                utm_term: get_cookie('utm_term'),
                utm_content: get_cookie('utm_content')
            },
            onQuestionChanged: () => {
                setShowSkipButton(false);
                const iframe = document.querySelector('.tf-v1-widget iframe');
                if (iframe) {
                    iframe.style.setProperty('height', '91dvh', 'important');
                }
            },
            onSubmit: ({ formId, responseId }) => {
                console.log(`Form ${formId} submitted with response id: ${responseId}`);
                localStorage.setItem('form_submitted', true);
                localStorage.setItem('form_submitted_at', new Date().toISOString());
                window.dataLayer?.push({ event: 'finish_quiz' });
            }
        });

        setWidgetInstance(widget);
    };

    useEffect(() => {
        let tf_url = localStorage.getItem('typeform_src') || window.checkoutConfig?.typeform_url;
        if (tf_url) initTypeform(tf_url);

        const handler = (e) => {
            if (e.detail?.typeformUrl) {
                localStorage.setItem('typeform_src', e.detail.typeformUrl);
                initTypeform(e.detail.typeformUrl);
            }
        };

        window.addEventListener('switchTypeform', handler);

        return () => {
            window.removeEventListener('switchTypeform', handler);
        };
    }, []);

    return (
        <>
            <div id="typeform-container" className={styles.formFrame} title="YesChef Personalization" />
            {showSkipButton && <a className={styles.SkipButton} href="/memberships?step=email">Skip</a>}
        </>
    );
};

export default TypeformComponent;
